import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e95412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "events swiper-button-next" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "events swiper-button-prev" }, null, -1))

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useInfo, useHome } from '@/store';
import { isPC, checkDirection } from '@/hooks/useCheck';
import { formatDate } from '@/hooks/useTransformTime';
import { Swiper as typeofSwiper } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Thumbs, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'EventsSlide',
  setup(__props) {

_useCssVars(_ctx => ({
  "8b5c7f98": (_unref(timeLeftArrow).pc),
  "5c8f010e": (_unref(timeLeftArrowActive).pc),
  "1388f5bf": (_unref(timeRightArrow).pc),
  "13cca259": (_unref(timeRightArrowActive).pc)
}))

const { setActiveIndex } = useHome();
const { currentYearEvents, thumbsSwiper } = storeToRefs(useHome());
const modules = [Thumbs, Navigation];
const navigation = {
  nextEl: '.events.swiper-button-next',
  prevEl: '.events.swiper-button-prev',
};
const onSlideChange = async (swiper: typeofSwiper) => {
  setActiveIndex(swiper.activeIndex);
};
const onUpdate = (swiper: typeofSwiper) => {
  swiper.slideTo(0);
};
const { getImg } = useInfo();
const timeLeftArrow = computed(() => ({
  pc: `url(${getImg('home_pc_time_left_arrow')})`,
}));
const timeLeftArrowActive = computed(() => ({
  pc: `url(${getImg('home_pc_time_left_arrow_active')})`,
}));
const timeRightArrow = computed(() => ({
  pc: `url(${getImg('home_pc_time_right_arrow')})`,
}));
const timeRightArrowActive = computed(() => ({
  pc: `url(${getImg('home_pc_time_right_arrow_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(currentYearEvents).length > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_unref(Swiper), {
          class: "event",
          dir: _unref(checkDirection),
          navigation: navigation,
          modules: modules,
          allowTouchMove: !_unref(isPC),
          grabCursor: !_unref(isPC),
          thumbs: { swiper: _unref(thumbsSwiper) },
          onSlideChange: onSlideChange,
          onUpdate: onUpdate
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentYearEvents), (event, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (event.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "logo",
                          src: event.logo,
                          alt: ""
                        }, null, 8, _hoisted_2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, _toDisplayString(event.title), 1),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(event.slogan) + " ", 1),
                        _createElementVNode("time", null, _toDisplayString(_unref(formatDate)(event.peakDay)), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["dir", "allowTouchMove", "grabCursor", "thumbs"]),
        (_unref(isPC))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _hoisted_5
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})